import React from 'react'

const NewPassword = ({ step, setStep, password, setPassword }) => {
    return (
        <div className="flex flex-col gap-3">
            <p className="text-4xs">Please enter your new password.</p>

            {/* <button
                type="submit"
                // onClick={handleSignup}
                // disabled={loginMutation.isLoading}
                className="secondary-button disabled:bg-opacity-70 w-full mt-6"
            >
                Submit
            </button> */}
            <button
                type="button"
                onClick={() => setStep("email")}
                className="primary-button disabled:bg-opacity-70 w-full my-3"
            >
                Update Password
            </button>

        </div>
    )
}

export default NewPassword;
